import styled, { FunctionInterpolation } from "@emotion/styled";
import { unstable_styleFunctionSx, SxProps } from "@mui/system";
interface DivProps {
  sx?: SxProps;
}

const Div = styled("div")<DivProps>(unstable_styleFunctionSx as FunctionInterpolation<DivProps>);

export default Div;
